export default {
  'profile.tabBookings': 'My Bookings',
  'profile.tabSaved': 'Saved Tours',
  'profile.tabSettings': 'Account Settings',
  'profile.traveler': 'Traveler',
  'profile.signingOut': 'Signing out...',
  'profile.signOut': 'Sign Out',
  'profile.loadingBookings': 'Loading your bookings...',
  'profile.somethingWrong': 'Something went wrong',
  'profile.tryAgain': 'Try again',
  'profile.noBookings': 'No bookings yet',
  'profile.noBookingsText': 'Explore our tours and start planning your Vietnam adventure.',
  'profile.exploreTours': 'Explore tours',
  'profile.bookingCode': 'Booking code',
  'profile.guest': 'guest',
  'profile.guests': 'guests',
  'profile.total': 'Total',
  'profile.noSaved': 'No saved tours',
  'profile.noSavedText': 'Tap the heart icon on any tour to save it here for later.',
  'profile.viewTour': 'View Tour',
  'profile.removeTour': 'Remove {{title}}',
  'profile.personalInfo': 'Personal Information',
  'profile.updateName': 'Update your name and contact details.',
  'profile.fullName': 'Full name',
  'profile.emailAddress': 'Email address',
  'profile.emailNote': 'Your email is used for sign-in and cannot be changed here.',
  'profile.saving': 'Saving...',
  'profile.saveChanges': 'Save Changes',
  'profile.changePassword': 'Change Password',
  'profile.keepSecure': 'Keep your account secure by updating your password regularly.',
  'profile.currentPassword': 'Current password',
  'profile.newPassword': 'New password',
  'profile.confirmNewPassword': 'Confirm new password',
  'profile.min6': 'Min. 6 characters',
  'profile.reenterNew': 'Re-enter new password',
  'profile.updated': 'Your profile has been updated.',
  'profile.passwordUpdated': 'Your password has been updated successfully.',
  'profile.enterCurrent': 'Please enter your current password.',
  'profile.newMin6': 'New password must be at least 6 characters.',
  'profile.newMismatch': 'New passwords do not match.',
  'profile.currentIncorrect': 'Your current password is incorrect.',
  'profile.updateFailed': 'Failed to update password. Please try again.',
  'profile.updating': 'Updating...',
  'profile.updatePassword': 'Update Password',
  'profile.hidePassword': 'Hide password',
  'profile.showPassword': 'Show password',
};